import { Building2, MapPin, Clock, Wrench, Bot, BookOpen, Rocket, type LucideIcon } from "lucide-react";

export interface StepMeta {
  key: string;
  title: string;
  subtitle: string;
  icon: LucideIcon;
}

// The wizard steps in order. "readiness" is the final review + completion screen.
export const STEP_META: StepMeta[] = [
  { key: "business_profile", title: "Business profile", subtitle: "Tell us about your business", icon: Building2 },
  { key: "location", title: "Location", subtitle: "Where customers reach you", icon: MapPin },
  { key: "hours", title: "Hours", subtitle: "When you're open", icon: Clock },
  { key: "services", title: "Services", subtitle: "What you offer", icon: Wrench },
  { key: "receptionist", title: "AI receptionist", subtitle: "Your virtual front desk", icon: Bot },
  { key: "faqs", title: "Knowledge", subtitle: "Answers your AI can trust", icon: BookOpen },
  { key: "readiness", title: "You're ready", subtitle: "Review & launch", icon: Rocket },
];

export const CONFIG_STEP_KEYS = ["business_profile", "location", "hours", "services", "receptionist", "faqs"];

export const INDUSTRIES = [
  { value: "HVAC", label: "HVAC" },
  { value: "Plumbing", label: "Plumbing" },
  { value: "Electrical", label: "Electrical" },
  { value: "Roofing", label: "Roofing" },
  { value: "Landscaping", label: "Landscaping" },
  { value: "Cleaning", label: "Cleaning services" },
  { value: "Pest Control", label: "Pest control" },
  { value: "General Contractor", label: "General contractor" },
  { value: "Other", label: "Other" },
];

export const TIMEZONES = [
  { value: "America/New_York", label: "Eastern (New York)" },
  { value: "America/Chicago", label: "Central (Chicago)" },
  { value: "America/Denver", label: "Mountain (Denver)" },
  { value: "America/Phoenix", label: "Mountain – no DST (Phoenix)" },
  { value: "America/Los_Angeles", label: "Pacific (Los Angeles)" },
  { value: "America/Anchorage", label: "Alaska (Anchorage)" },
  { value: "Pacific/Honolulu", label: "Hawaii (Honolulu)" },
];

export const AFTER_HOURS = [
  { value: "voicemail", label: "Take a message (voicemail)" },
  { value: "ai_message", label: "AI answers and takes a message" },
  { value: "emergency_only", label: "Emergencies only, otherwise message" },
  { value: "transfer", label: "Transfer to a person" },
];

export const PRICE_TYPES = [
  { value: "range", label: "Price range" },
  { value: "fixed", label: "Fixed price" },
  { value: "starting_at", label: "Starting at" },
  { value: "quote", label: "Quote required" },
];

export const TONES = [
  { value: "friendly-professional", label: "Friendly & professional" },
  { value: "warm", label: "Warm & welcoming" },
  { value: "concise", label: "Concise & efficient" },
  { value: "formal", label: "Formal" },
];

export const DAYS = [
  { dow: 0, label: "Sunday" },
  { dow: 1, label: "Monday" },
  { dow: 2, label: "Tuesday" },
  { dow: 3, label: "Wednesday" },
  { dow: 4, label: "Thursday" },
  { dow: 5, label: "Friday" },
  { dow: 6, label: "Saturday" },
];
